import { Role } from '~/common/providers/auth/role';

const allocationsAllowedRolesV2: Role[] = ['LOGLASS_SYSTEM_ADMIN', 'TENANT_ADMIN', 'CORP_PLANNING'];

export { allocationsAllowedRolesV2 };
